// contexts/ShopContext.js
import React, { createContext, useState, useContext } from 'react';

const ShopContext = createContext();

export const useShop = () => {
  const context = useContext(ShopContext);
  if (!context) {
    throw new Error('useShop must be used within ShopProvider');
  }
  return context;
};

export const ShopProvider = ({ children }) => {
  const [currentShopId, setCurrentShopId] = useState(null);
  const [currentShop, setCurrentShop] = useState(null);

  const value = {
    currentShopId,
    currentShop,
    setCurrentShop,
    setCurrentShopId
  };

  return (
    <ShopContext.Provider value={value}>
      {children}
    </ShopContext.Provider>
  );
};